import BaseForm from '../base';
export class SitePanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
